"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jwtDecode = _interopRequireDefault(require("jwt-decode"));
var _appConfigHelper = require("../util/appConfigHelper");
var _getCaptureStatus = _interopRequireDefault(require("../api/Customer/getCaptureStatus"));
var _getCustomerConsents = _interopRequireDefault(require("../api/Customer/getCustomerConsents"));
class Auth {
  constructor() {
    this.isAuthenticated = false;
    this.myAccount = {
      mainPage: '/my-account/plan-details',
      loginPage: '/my-account/login'
    };
    this.checkout = {
      mainPage: '/offer',
      loginPage: '/login'
    };
    this.capturePage = '/capture';
    this.consentsPage = '/consents';
  }
  login() {
    let isMyAccount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    let isRegister = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let email = arguments.length > 2 ? arguments[2] : undefined;
    let jwt = arguments.length > 3 ? arguments[3] : undefined;
    let refreshToken = arguments.length > 4 ? arguments[4] : undefined;
    let cb = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : t => t;
    let args = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
    let callback = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : t => t;
    this.isAuthenticated = true;
    const {
      customerId
    } = (0, _jwtDecode.default)(jwt);
    (0, _appConfigHelper.setData)('CLEENG_CUSTOMER_ID', customerId);
    (0, _appConfigHelper.setData)('CLEENG_AUTH_TOKEN', jwt);
    (0, _appConfigHelper.setData)('CLEENG_REFRESH_TOKEN', refreshToken);
    (0, _appConfigHelper.setData)('CLEENG_CUSTOMER_EMAIL', email);
    if (cb) cb.apply(this, args);
    const redirectUrl = isMyAccount ? this.myAccount.mainPage : this.checkout.mainPage;
    let shouldConsentsBeDisplayed = false;
    let shouldCaptureBeDisplayed = false;
    let data = {};
    const consentsResponse = (0, _getCustomerConsents.default)().then(resp => {
      const {
        consents
      } = resp.responseData;
      shouldConsentsBeDisplayed = isRegister ? false : consents.some(consent => consent.newestVersion > consent.version || consent.needsUpdate === true);
    });
    const captureResponse = (0, _getCaptureStatus.default)().then(resp => {
      if (resp.responseData.shouldCaptureBeDisplayed === true) {
        shouldCaptureBeDisplayed = true;
        data = {
          ...data,
          settings: resp.responseData.settings
        };
      }
    });
    Promise.allSettled([consentsResponse, captureResponse]).then(() => {
      data = {
        ...data,
        redirectUrl: [shouldCaptureBeDisplayed ? this.capturePage : null, shouldConsentsBeDisplayed ? this.consentsPage : null, redirectUrl].filter(Boolean)
      };
    });
    callback();
  }
  logout() {
    let callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : t => t;
    this.isAuthenticated = false;
    (0, _appConfigHelper.removeData)('CLEENG_AUTH_TOKEN');
    (0, _appConfigHelper.removeData)('CLEENG_REFRESH_TOKEN');
    (0, _appConfigHelper.removeData)('CLEENG_ORDER_ID');
    (0, _appConfigHelper.removeData)('CLEENG_CHECKOUT_PP_SUCCESS');
    (0, _appConfigHelper.removeData)('CLEENG_CHECKOUT_PP_CANCEL');
    (0, _appConfigHelper.removeData)('CLEENG_CHECKOUT_PP_ERROR');
    (0, _appConfigHelper.removeData)('CLEENG_MYACCOUNT_PP_SUCCESS');
    (0, _appConfigHelper.removeData)('CLEENG_MYACCOUNT_PP_CANCEL');
    (0, _appConfigHelper.removeData)('CLEENG_MYACCOUNT_PP_ERROR');
    (0, _appConfigHelper.removeData)('CLEENG_CUSTOMER_EMAIL');
    (0, _appConfigHelper.removeData)('CLEENG_CUSTOMER_ID');
    (0, _appConfigHelper.removeData)('CLEENG_ENVIRONMENT');
    (0, _appConfigHelper.removeData)('CLEENG_PUBLISHER_ID');
    callback();
  }
  isLogged() {
    const jwt = (0, _appConfigHelper.getData)('CLEENG_AUTH_TOKEN');
    const refreshToken = (0, _appConfigHelper.getData)('CLEENG_REFRESH_TOKEN');
    if (!jwt) {
      this.isAuthenticated = !!refreshToken;
      return this.isAuthenticated;
    }
    const decoded = (0, _jwtDecode.default)(jwt);
    const now = Date.now() / 1000;
    const isExpired = now > decoded.exp;
    if (isExpired && !refreshToken) {
      this.logout();
    } else {
      this.isAuthenticated = true;
    }
    return this.isAuthenticated;
  }
}
var _default = exports.default = new Auth();